<template>
  <div>
    <v-list-tile @click="mostrarCaixaDialogo">
      <v-list-tile-title>
        Inabilitar
      </v-list-tile-title>
    </v-list-tile>

    <modal-generico :visivel.sync="visibilidadeDialogo"
                    @fechar="fecharCaixaDialogo"
                    @confirmar="inabilitar" >

      <template v-slot:header>
        <span><strong>{{itemOuLoteDescricao}} | Inabilitar Fornecedor</strong></span>
      </template>

      <template v-slot:primario>
        <div>
          <div class="az-text mb-3">
            <label>Fornecedor</label>
            <p>{{razaoSocial}}</p>
          </div>

          <v-textarea v-model="motivoInabilitacao"
                      :error-messages="errors.collect('Motivo da Inabilitação ' + itemOuLoteDescricao)"
                      v-validate="'required'"
                      label="Motivo da Inabilitação"
                      :name="'Motivo da Inabilitação ' + itemOuLoteDescricao"
                      placeholder="Digite aqui seu motivo"
                      rows="3"
                      maxlength="1000"
                      :counter="1000"/>

          <v-checkbox
              v-model="inabilitarTodos"
              label="Inabilitar fornecedor para todos os itens ou grupos da compra"/>
        </div>
      </template>

      <template v-slot:acoes>
          <v-btn color="botao-cancelar-color" flat outline @click="fecharCaixaDialogo">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn id="botaoInabilitar" color="primary" depressed @click="inabilitar">
            Confirmar
          </v-btn>
      </template>

    </modal-generico>
  </div>
</template>

<script>
import ModalGenerico from '@/views/components/ModalGenerico.vue'

export default {
    name: 'AcoesInabilitar',
    $_veeValidate: {
        validator: 'new'
    },
    components: {ModalGenerico},
    props:['itemOuLoteDescricao', 'razaoSocial'],
    data() {
        return {
            visibilidadeDialogo: false,
            motivoInabilitacao: null,
            inabilitarTodos: false,
            dados: {}
        }
    },
    methods: {
        mostrarCaixaDialogo() {
            setTimeout(() => {
                this.limparCampos()
                this.visibilidadeDialogo = true
            }, 500)
        },
        fecharCaixaDialogo() {
            this.limparCampos()
            this.visibilidadeDialogo = false
        },
        async inabilitar() {
            await this.validarPreenchimento()
            const dados = {
                motivo: this.motivoInabilitacao,
                inabilitarTodos: this.inabilitarTodos
            }
            this.$emit('inabilitar', dados)
            this.fecharCaixaDialogo()
        },
        limparCampos() {
            this.inabilitarTodos = false
            this.motivoInabilitacao = null
            this.$validator.reset()
        },
        async validarPreenchimento() {
            this.$nextTick(async () => {
                const estaValidado = await this.$validator.validate('Motivo da Inabilitação ' + this.itemOuLoteDescricao)
                if (!estaValidado) {
                    throw new Error('Preencha todos os campos obrigatorios')
                }
            })
        }
    },
    destroyed() {
        this.fecharCaixaDialogo()
    }
}
</script>

<style scoped lang="stylus">
</style>